import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./css/index.css";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration.js";

const root = ReactDOM.createRoot(document.getElementById("page"));
const startApp = () => {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
  serviceWorkerRegistration.register();
};

// Short links are resolved by the script in public/index.html. The app only starts when that
// script hands over (link missing or lookup failed), so a redirect never waits on React.
const shortLink = window.__liteRedirect;
if (shortLink) {
  shortLink.done.then((outcome) => {
    if (outcome !== "redirected") startApp();
  });
} else {
  startApp();
}
